import React from 'react'

const BlogsCard = () => {
    return (
        <div className="landing-container-blogs-card">
            <img src='https://picsum.photos/200/300' />
            <h2>Dunya Hizmetlerimiz</h2>
            <p>Boost your app’s capabilities scalability and stability.Boost your app’s capabilities without worrying about scalability and stability.</p>
            <div className="btn-center">
                <button>
                    DEVAMINI GOR <i className="fas fa-angle-right"></i>
                </button>
            </div>
        </div>
    )
}

export default BlogsCard
